var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartAnswers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03226,0,0,1.03226,256,256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Smart-Answers",
    serifId: "Smart Answers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "idea",
    transform: "matrix(1,0,0,1,-248,-248)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M496,472L496,264C495.984,263.102 495.813,262.215 495.496,261.375C495.434,261.18 495.359,260.988 495.273,260.801C494.922,259.969 494.438,259.203 493.832,258.535C493.762,258.465 493.672,258.414 493.602,258.344C493.234,257.961 492.828,257.613 492.391,257.313C492.094,257.141 491.781,256.988 491.465,256.855C491.359,256.809 491.289,256.711 491.176,256.664L416,224.105L416,24C416,19.582 412.418,16 408,16L88,16C83.582,16 80,19.582 80,24L80,224.105L4.801,256.664C4.68,256.711 4.609,256.816 4.496,256.863C4.184,256.996 3.879,257.148 3.586,257.313C3.148,257.613 2.742,257.961 2.375,258.344C2.305,258.414 2.215,258.465 2.145,258.535C1.539,259.203 1.055,259.969 0.703,260.801C0.617,260.988 0.543,261.18 0.48,261.375C0.172,262.219 0.008,263.105 0,264L0,472C0,476.418 3.582,480 8,480L488,480C492.418,480 496,476.418 496,472ZM467.871,264L416,286.48L416,241.543L467.871,264ZM400,32L400,293.414L248,359.281L96,293.414L96,32L400,32ZM80,286.48L28.129,264L80,241.543L80,286.48ZM480,464L16,464L16,276.184L244.801,375.336C246.824,376.223 249.129,376.223 251.152,375.336L480,276.184L480,464Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,249.289L216,264L208,264C203.582,264 200,267.582 200,272L200,296C200,300.418 203.582,304 208,304L208,320C208,324.418 211.582,328 216,328L280,328C284.418,328 288,324.418 288,320L288,304C292.418,304 296,300.418 296,296L296,272C296,267.582 292.418,264 288,264L280,264L280,249.289C314.719,234.133 334.051,196.707 326.313,159.621C318.574,122.539 285.883,95.965 248,95.965C210.117,95.965 177.426,122.539 169.688,159.621C161.949,196.707 181.281,234.133 216,249.289ZM216,280L280,280L280,288L216,288L216,280ZM272,312L224,312L224,304L272,304L272,312ZM248,112C279.125,112.055 305.695,134.492 310.965,165.168C316.23,195.844 298.668,225.859 269.344,236.297C266.145,237.422 264,240.445 264,243.84L264,264L232,264L232,243.84C232,240.445 229.855,237.422 226.656,236.297C197.332,225.859 179.77,195.844 185.035,165.168C190.305,134.492 216.875,112.055 248,112Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,80C252.418,80 256,76.418 256,72L256,56C256,51.582 252.418,48 248,48C243.582,48 240,51.582 240,56L240,72C240,76.418 243.582,80 248,80Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,184L144,184C148.418,184 152,180.418 152,176C152,171.582 148.418,168 144,168L136,168C131.582,168 128,171.582 128,176C128,180.418 131.582,184 136,184Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,184L368,184C372.418,184 376,180.418 376,176C376,171.582 372.418,168 368,168L352,168C347.582,168 344,171.582 344,176C344,180.418 347.582,184 352,184Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.152,268.848C165.273,268.848 167.309,268.004 168.809,266.504L180.121,255.199C183.246,252.074 183.246,247.008 180.121,243.879C176.992,240.754 171.926,240.754 168.801,243.879L157.496,255.199C155.207,257.488 154.523,260.93 155.762,263.918C157,266.906 159.918,268.855 163.152,268.855L163.152,268.848Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.535,110.465C323.656,110.465 325.691,109.621 327.191,108.121L338.504,96.801C341.41,93.645 341.309,88.758 338.273,85.727C335.242,82.691 330.355,82.59 327.199,85.496L315.879,96.801C313.594,99.09 312.91,102.527 314.148,105.516C315.383,108.508 318.301,110.457 321.535,110.457L321.535,110.465Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.801,108.121C171.926,111.246 176.992,111.246 180.121,108.121C183.246,104.992 183.246,99.926 180.121,96.801L168.801,85.496C166.813,83.336 163.797,82.438 160.949,83.16C158.102,83.879 155.879,86.102 155.16,88.949C154.438,91.797 155.336,94.813 157.496,96.801L168.801,108.121Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.199,243.879C324.074,240.754 319.008,240.754 315.879,243.879C312.754,247.008 312.754,252.074 315.879,255.199L327.199,266.504C330.355,269.41 335.242,269.309 338.273,266.273C341.309,263.242 341.41,258.355 338.504,255.199L327.199,243.879Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,448L424,448C428.418,448 432,444.418 432,440C432,435.582 428.418,432 424,432L352,432C347.582,432 344,435.582 344,440C344,444.418 347.582,448 352,448Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448,448L456,448C460.418,448 464,444.418 464,440C464,435.582 460.418,432 456,432L448,432C443.582,432 440,435.582 440,440C440,444.418 443.582,448 448,448Z",
    style: {
      fill: "rgb(55,201,119)",
      fillRule: "nonzero"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "idea1",
    serifId: "idea"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartAnswers);
export default __webpack_public_path__ + "static/media/smart-answers.295639d28f3c36f6be8a329b1b0d865a.svg";
export { ForwardRef as ReactComponent };